export default __webpack_public_path__ + "static/media/1StuckInMyWays.b85324db.png";